export class Note {
  id: string;
  taskId: string;
  text ?: string;
  type?: number;
  timestampStart ?: number;
  timestampEnd ?: number;
  fileName ?: string;
  dateCreated ?: number;
  taskAssignmentId ?: string;
  url ?: string;
}
